import React, { useState }  from "react"
import { Div } from "atomize";
import { pages } from "../../../Constants/constants";
import Tab from "./../../Atoms/Tab";
import styled from "styled-components";
import { useScrollPosition } from './../../../utils/getScrollPosition';
import theme from './../../../Theme/Theme';
import HamburgerMenu from 'react-hamburger-menu';
import useWindowSize from './../../../utils/useWindowSize';
import Routes from "../../../Routes";
import {withRouter} from "react-router-dom";

const Wrapper = styled(Div)`
  border-radius: 8px;
  overflow: hidden;
  padding: 0 8px;
  width: ${ props => props.ishidden === "true" ? '60px' : '470px'};
  transition: width .25s ease-in-out, height .25s ease-in-out;
  height: 58px;
  z-index: 100;
  
  @media only screen and (max-width: 766px) {
  
    justify-content: center;
    z-index: ${ props => props.ishidden === "true" ? '100' : '400'};
    width: ${ props => props.ishidden === "true" ? '60px' : 'calc(100vw - 2rem)'};
    height: ${ props => props.ishidden === "true" ? '58px' : 'calc(100vh - 2rem)'};
    flex-direction: column;
    align-items: center;
    
    a.menu-trigger {
      position: absolute;
      top: 0;
    }
    
    a.tab {
      display: inline-flex;
      justify-content: center;
      width: max-content;
      font-size: 24px;
      padding: 0 !important;
      height: 40px;
      margin: 1rem 1rem;
    }
  }
`;

const MenuTriggerWrapper = styled.a`
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  width: 60px;
  position: absolute;
  right: 0;
  background-color: white;
`;

const Overlay = styled(Div)`
  opacity: .5;
`;

function Menu(props) {
  const page = Routes.filter( route => {
    return route.path === "/" + props.location.pathname.split('/')[1]
  });
  let pageTitle = '';
  if (page.length > 0) {
    pageTitle = page[0].name;
  }

  const size = useWindowSize();
  const [isHidden, setIsHidden] = useState(size.width < 767);

  useScrollPosition(({ prevPos, currPos }) => {
    if (size.width > 766) {
      if (currPos.y === 0) {
        setIsHidden(false);
      }
      else if (!isHidden && prevPos.y > currPos.y) {
        setIsHidden(true);
      }
      else if (isHidden && currPos.y - 50 > prevPos.y) {
        setIsHidden(false);
      }
    }
  }, [isHidden]);

  const renderMenuHorizonatal = () => {
    return (
      pages.map( eachPage => {
        return (
          <Tab
            key={eachPage}
            title={eachPage}
            active={pageTitle === eachPage}
            className={`menu-link ${pageTitle}`}
            action={ size.width > 766 ? null : () => setIsHidden(!isHidden) }
          />
        )
      })
    );
  };

  return (
    <>
      {
        !isHidden && size.width < 767 &&
        <Overlay
          bg={theme.colors.primary}
          pos="fixed"
          top={0}
          bottom={0}
          left={0}
          right={0}
          h={'100vh'}
          w={'100vw'}
        />
      }
      <Wrapper
        shadow={5}
        bg="white"
        pos="fixed"
        top={{ xs: '1rem', md: '2rem' }}
        right={{ xs: '1rem', md: '7rem' }}
        d="flex"
        ishidden={isHidden ? "true" : "false"}
      >
        <MenuTriggerWrapper
          onClick={() => setIsHidden(!isHidden)}
          aria-label={isHidden ? 'Open menu' : 'Close menu'}
          aria-expanded={!isHidden}
          role={'link'}
          tabIndex={0}
          className={'menu-trigger'}
        >
          <HamburgerMenu
            menuClicked={() => null}
            isOpen={!isHidden}
            width={18}
            height={15}
            strokeWidth={2}
            rotate={0}
            color={theme.colors.primary}
            borderRadius={0}
            animationDuration={0.5}
          />
        </MenuTriggerWrapper>
        { !isHidden &&
          renderMenuHorizonatal()
        }
      </Wrapper>
    </>
  )
}



export default withRouter(Menu);
